import { render, staticRenderFns } from "./StyleCategoryArea.vue?vue&type=template&id=36f3ee90&scoped=true&"
import script from "./StyleCategoryArea.vue?vue&type=script&lang=js&"
export * from "./StyleCategoryArea.vue?vue&type=script&lang=js&"
import style0 from "./StyleCategoryArea.vue?vue&type=style&index=0&id=36f3ee90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f3ee90",
  null
  
)

export default component.exports